import { Component, Input, input } from '@angular/core';
import { Card, CardCatalog, ProductCatalogResponse } from '../../../../../../../core/models/summary-data';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductSelectionService } from '../../../../../../../core/services/product-selection.service';
import { CatalogService } from '../../../../../../../core/services/catalog.service';

@Component({
  selector: 'app-catalog-home',
  standalone: false,
  templateUrl: './catalog-home.component.html',
  styleUrl: './catalog-home.component.scss'
})
export class CatalogHomeComponent {

  categoriesMap: { [key: string]: Card[] } = {};
  result: any[] = [];
  isInExtraStep = false;
  @Input() form!: FormGroup;
  productCatalog: ProductCatalogResponse = {} as ProductCatalogResponse;
  brandingId: string = '';

  constructor(private translate: TranslateService, private router: Router, private productService: ProductSelectionService,
    private productCatalogService: CatalogService, private route: ActivatedRoute,
  ) {}

  ngOnInit() {

    this.brandingId = this.route.snapshot.queryParamMap.get('brandingId') || '';

    // const catalog = this.productCatalogService.getCatalog();
    // if (catalog) {
    //   this.productCatalog = catalog;
    //   console.log('Catalogo:', this.productCatalog);
    // } else {
    //   console.warn('No hay catálogo disponible');
    // }
    
    this.router.events.subscribe(() => {
      const url = this.router.url;
      this.isInExtraStep = url.includes('refueling') || url.includes('wash');
    });

    const savedProductCatalog = localStorage.getItem('ProductCatalogResponse');
    if (savedProductCatalog) {
      this.productCatalog = JSON.parse(savedProductCatalog);
      this.categoriesMap = this.mergeCategoriesWithProductCatalogResponse(this.productCatalog);
    } else if (this.productCatalog) {
      this.categoriesMap = this.mergeCategoriesWithProductCatalogResponse(this.productCatalog);
      localStorage.setItem('ProductCatalogResponse', JSON.stringify(this.productCatalog));
    }
  }

  

  myCategories: CardCatalog[] = [
    {
      title: 'transfers',
      products: [
        {
          id: 'transfer',
          icon: 'assets/icons/transfer-icon.svg',
          title: 'transfer',
          description: 'transfer_point_A_to_B',
          info: 'Más información sobre el Servicio 1',
          isTransfer: undefined,
        },
      ],
    },
    {
      title: 'maintenance',
      products: [
        {
          id: 'refueling-car-topping',
          icon: 'assets/icons/fueling-icon.svg',
          title: 'refueling',
          description: 'refueling_description',
          needsPersonalization: true,
          isTransfer: undefined,
        },
      ],
    },
    {
      title: 'washes',
      products: [
        {
          id: 'specialized-center-wash',
          icon: '/assets/icons/wash-icon.svg',
          title: 'wash_specialized_centers',
          description: 'specialized_center_wash_description',
          personalizationDescription:
            'specialized_center_wash_description_catalog',
          info: 'Más información sobre el Servicio 1',
          isTransfer: undefined,
          relatedCards: [
            {
              id: 'tunnel-interior-car-wash',
              icon: 'assets/icons/washing-specialist-center-inside.svg',
              title: 'interior',
              description: 'tunnel_car_wash_description_interior',
              personalizationDescription:
                'specialized_center_wash_description_catalog',
              info: 'Más información sobre el Servicio 1',
              isTransfer: undefined,
            },
            {
              id: 'tunnel-exterior-car-wash',
              icon: 'assets/icons/washing-specialist-center-outside.svg',
              title: 'exterior',
              description: 'tunnel_car_wash_description_exterior',
              personalizationDescription:
                'specialized_center_wash_description_catalog',
              info: 'Más información sobre el Servicio 1',
              isTransfer: undefined,
            },
            {
              id: 'tunnel-complete-car-wash',
              icon: 'assets/icons/washing-specialist-center-complete-icon.svg',
              title: 'complete',
              description: 'tunnel_car_wash_description_complete',
              personalizationDescription:
                'specialized_center_wash_description_catalog',
              info: 'Más información sobre el Servicio 1',
              isTransfer: undefined,
            },
          ],
        },
      ],
    },
    {
      title: 'parking',
      products: [
        {
          id: 'parking',
          icon: 'assets/icons/parking-icon.svg',
          title: 'parking',
          description:
            'Encuentra un parking disponible cerca de ti estés donde estés.',
          info: 'Más información sobre el Servicio 1',
          isTransfer: undefined,
        },
        {
          id: 'valet-station',
          icon: 'assets/icons/valet-icon.svg',
          title: 'valet',
          description:
            'Recogemos tu vehículo antes de tu viaje, lo guardamos y te lo entregamos a la vuelta.',
          info: 'Más información sobre el Servicio 1',
          isTransfer: undefined,
        },
      ],
    },
    {
      title: 'formalities',
      products: [
        {
          id: 'ownership-change',
          icon: 'assets/icons/name-change-icon.svg',
          title: 'ownership_change',
          description: 'Realizamos los interminables papeleos por ti.',
          info: 'Más información sobre el Servicio 1',
          needsPersonalization: true,
          isTransfer: undefined,
        },
      ],
    },
  ];

  selectedProduct: any = null;
  selectedSubproduct: any = null;

  mergeCategoriesWithProductCatalogResponse(mockData: ProductCatalogResponse): {
    [key: string]: Card[];
  } {
    const categoryMap: { [key: string]: Card[] } = {};

    if (!mockData.Categories) {
      return categoryMap;
    }

    for (const productCatalogCategory of mockData.Categories) {
      const matchingCategory = this.myCategories.find(
        (category) => category.title === productCatalogCategory.Title
      );

      if (matchingCategory) {
        if (!productCatalogCategory.Products) {
          continue;
        }

        if (!categoryMap[matchingCategory.title]) {
          categoryMap[matchingCategory.title] = [];
        }

        for (const productCatalogProduct of productCatalogCategory.Products) {
          const matchingProduct = matchingCategory.products.find(
            (product) => product.id === productCatalogProduct.ProductKey
          );

          if (matchingProduct) {
            const updatedProduct = {
              ...matchingProduct,
              ...productCatalogProduct,
              title: this.translate.instant(matchingProduct.title || ''),
              description: this.translate.instant(matchingProduct.description || ''),
              personalizationDescription: matchingProduct.personalizationDescription
                ? this.translate.instant(matchingProduct.personalizationDescription)
                : '',
              outOfRange:
                productCatalogProduct.Price === 0 && matchingProduct.id === 'medium-long-distance',
            };

            if (matchingProduct.relatedCards && matchingProduct.relatedCards.length > 0) {
              const updatedRelatedCards: Card[] = [];
              for (const relatedCard of matchingProduct.relatedCards) {
                const relatedProduct = productCatalogProduct?.RelatedProducts?.find(
                  (product) => product.ProductKey === relatedCard.id
                );
                if (relatedProduct) {
                  updatedRelatedCards.push({
                    ...relatedCard,
                    ...relatedProduct,
                    title: this.translate.instant(relatedCard.title || ''),
                    description: this.translate.instant(relatedCard.description || ''),
                    personalizationDescription: relatedCard.personalizationDescription
                      ? this.translate.instant(relatedCard.personalizationDescription)
                      : '',
                  } as Card);
                }
              }
              updatedProduct.relatedCards = updatedRelatedCards;
            }
            categoryMap[matchingCategory.title].push(updatedProduct);
          }
        }
      }
    }
    this.flattenCategoryMap(categoryMap)
    return categoryMap;
  }

  flattenCategoryMap(categoryMap: { [key: string]: any[] }): any[] {
    const result: any[] = [];
    let index = 0;
  
    for (const category in categoryMap) {
      if (categoryMap.hasOwnProperty(category)) {
        for (const product of categoryMap[category]) {
          result.push({
            ...product,
            category,
            index
          });
          index++;
        }
      }
    }
    this.result = result;
    return result;
  }
  
  onServiceSelected(item: any): void {
    this.productService.saveProduct(item);
    const routes: { [key: string]: string } = {
      'refueling-car-topping': '/funnel/catalog/refueling',
      'specialized-center-wash': '/funnel/catalog/wash',
      'ownership-change': '/funnel/catalog/ownership-change',
      'parking': '/funnel/catalog/parking',
    };

    const route = routes[item.ProductKey];
    if (route) {
      this.router.navigate([route], {
        state: { selectedItem: item },
        queryParams: {brandingId : this.brandingId}
      });
    } else {
      this.router.navigate(['/funnel/catalog/default'], {
        state: { selectedItem: item },
        queryParams: {brandingId : this.brandingId}
      });
    }
  }

}
